"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CollapseOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var CollapseOutlineSVG = function CollapseOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M28.64 14.07l-9.83.1a1.1 1.1 0 01-.79-.35 1 1 0 01-.34-.78l.09-9.86a1.08 1.08 0 011.07-1.07 1 1 0 011.05 1.05l-.08 7.48 8.81-8.84A1 1 0 1130 3.21L21.21 12h7.45a1 1 0 011 1 1.07 1.07 0 01-1.02 1.07zM2.3 19a1 1 0 001 1h7.49L2 28.79a1 1 0 001.38 1.41l8.81-8.84-.08 7.48a1 1 0 001.05 1.05 1.08 1.08 0 001.07-1.07l.09-9.82a1 1 0 00-.34-.78 1.1 1.1 0 00-.79-.35l-9.83.1A1.07 1.07 0 002.3 19z"
  }));
};
exports.CollapseOutlineSVG = CollapseOutlineSVG;
CollapseOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CollapseOutlineSVG);
exports.default = _default;